import DashboardReport from './DashboardReportBreakdownContainer';

export default DashboardReport;
